import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ListPublicaciones from './Components/ListPublicaciones';
import PublicacionNew from './Components/ABM/PublicacionNew';
import PublicacionEdit from './Components/ABM/PublicacionEdit';
import CreacionMasivaPublicaciones from './Components/Excel/CreacionMasivaPublicaciones';
import CreacionMasivaWizard from './Components/Excel/CreacionMasivaWizard';
import ActualizacionMasivaPublicaciones from './Components/Excel/ActualizacionMasivaPublicaciones';
import ActualizacionMasivaWizard from './Components/Excel/ActualizacionMasivaWizard';
import { getFrontendFeatureFlag } from '../../utilities/frontendConfig';
import { isProductionRuntime } from '../../utilities/runtimeEnvironment';

export default class AdmPublicaciones extends React.Component {
    render () {
        const defaultWizardVisibility = !isProductionRuntime();
        const showCreacionMasivaWizard = getFrontendFeatureFlag(
            ['publicaciones', 'showCreacionMasivaWizard'],
            defaultWizardVisibility
        );
        const showActualizacionMasivaWizard = getFrontendFeatureFlag(
            ['publicaciones', 'showActualizacionMasivaWizard'],
            defaultWizardVisibility
        );

        return (
            <div>
                <Routes>
                    <Route path="" element={<ListPublicaciones/>}/>
                    <Route path="Nueva/:idSeller" element={<PublicacionNew/>}/>
                    <Route path="Editar/:idSeller/:id" element={<PublicacionEdit/>}/>
                    <Route path="CreacionMasiva" element={<CreacionMasivaPublicaciones/>}/>
                    <Route
                        path="CreacionMasivaWizard"
                        element={showCreacionMasivaWizard ? <CreacionMasivaWizard/> : <Navigate to="/Publicaciones/CreacionMasiva" replace />}
                    />
                    <Route path="ActualizacionMasiva" element={<ActualizacionMasivaPublicaciones/>} />
                    <Route
                        path="ActualizacionMasivaWizard"
                        element={showActualizacionMasivaWizard ? <ActualizacionMasivaWizard/> : <Navigate to="/Publicaciones/ActualizacionMasiva" replace />}
                    />
                </Routes>
            </div>
        );
    }
}
